import { useMemo } from "react";
import { marked } from "marked";
import DOMPurify from "dompurify";

/**
 * (From the Cordino App)
 * Displays Markdown content as HTML. Takes a `content` prop with a markdown string
 * and all remaining props are passed on to the parent <article> element.
 *
 * This component doesn't offer any styling of its own, but you can pass a `className`
 * to define it yourself for the particular use case.
 */
export function Markdown({ content, ...props }) {
  const rendered = useMemo(() => {
    const html = content
      ? marked.parse(content.replace(/linebreaktag/gi, "<p><br/></p>"))
      : "";
    return DOMPurify.sanitize(html, {
      // Allow only valid HTML tags (no SVG or MathML)
      USE_PROFILES: { html: true },

      // Disallow custom styling. These could potentially cause problems with layout or other elements.
      FORBID_TAGS: ["style"],
      FORBID_ATTR: ["style"],
    });
  }, [content]);

  return <article {...props} dangerouslySetInnerHTML={{ __html: rendered }} />;
}
